/**
 * A utility function to catch errors in asynchronous code.
 * Wraps a promise and returns an array where the first element
 * is the error (if any) and the second element is the resolved value.
 *
 * ref: https://youtu.be/AdmGHwvgaVs?si=W4RR0nEO9OV0gE-u&t=250
 *
 * Example:
 *
 * ```
 * const [error, user] = await catchError(getUserById(123))
 * if (error) {
 *   console.log("There was an error", error.message)
 * } else {
 *   console.log(user)
 * }
 * ```
 */
export const catchError = async <T>(
  promise: Promise<T>
): Promise<[undefined, T] | [Error]> => {
  return promise
    .then(data => {
      return [undefined, data] as [undefined, T]
    })
    .catch(error => {
      return [error]
    })
}
